import PropTypes from 'prop-types';
import React, { ReactText } from 'react';

import t from '../../../labels/labelling-utils';
import { IClassNames, makeClassNames } from '../../../utils/styles';
import IconStar from '../../atoms/icons/icon-star';
import Tooltip from '../../atoms/tooltip/tooltip';
import Text from '../../atoms/text/text';

import './report-player.scss';

export interface IReportPlayer {
  fullname?: string | null; // Just like IReferee interface in src/typings/player.ts
  topPlayer?: boolean;
  vote?: ReactText;
  isAway?: boolean;
  playerPageLink?: string;
}

const classNames = (isAway: boolean | undefined, playerPageLink: boolean | undefined): IClassNames =>
  makeClassNames({
    reportPlayer: 'report-player',
    name: ['report-player__name', playerPageLink && 'report-player__name--link'],
    vote: ['report-player__vote', isAway && 'report-player__vote--away'],
  });

const ReportPlayer: React.FC<IReportPlayer> = ({
  /* istanbul ignore next: default value */ topPlayer = false,
  /* istanbul ignore next: default value */ fullname = '',
  isAway,
  vote,
  playerPageLink,
}) => {
  const cn = classNames(isAway, Boolean(playerPageLink));

  return (
    <div className={cn.reportPlayer}>
      <Text
        className={cn.name}
        href={playerPageLink}
        color="blue"
        fontWeight="500"
        fontSize="14"
        tag={playerPageLink ? 'a' : 'span'}
      >
        {fullname}
        {topPlayer && (
          <Tooltip text={t('report.top.player')}>
            <IconStar size="xxsmall" color="red-lighter" />
          </Tooltip>
        )}
      </Text>
      <span className={cn.vote}>{vote}</span>
    </div>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  ReportPlayer.propTypes = {
    fullname: PropTypes.string.isRequired,
    isAway: PropTypes.bool,
    playerPageLink: PropTypes.string,
    topPlayer: PropTypes.bool,
    vote: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };
}

export default ReportPlayer;
